import { useEffect, useState } from "react";
import {
    DEFAULT_RATING_COLOR_THRESHOLD,
    fetchRatingColorThreshold,
    type RatingColorThreshold,
} from "../../api/rate5Why.api";

const RATING_LABEL = "Оценка качества решения проблемы";

export const getRatingBg = (
    score: number,
    thresholds: RatingColorThreshold = DEFAULT_RATING_COLOR_THRESHOLD,
): string => {
    if (score >= thresholds.greenFromPercent) return "bg-[#ACEFC8]";
    if (score >= thresholds.yellowFromPercent) return "bg-[#FEF3C7]";
    return "bg-[#FDD8D8]";
};

export const getRatingTextColor = (
    score: number,
    thresholds: RatingColorThreshold = DEFAULT_RATING_COLOR_THRESHOLD,
): string => {
    if (score >= thresholds.greenFromPercent) return "text-[#057A55]";
    if (score >= thresholds.yellowFromPercent) return "text-[#9F580A]";
    return "text-[#BA0C2F]";
};

type RatingBadgeProps = {
    score: number;
};

export const RatingBadge = ({ score }: RatingBadgeProps) => {
    const [colorThresholds, setColorThresholds] = useState<RatingColorThreshold>(DEFAULT_RATING_COLOR_THRESHOLD);

    useEffect(() => {
        fetchRatingColorThreshold().then(setColorThresholds);
    }, []);

    return (
        <div className={`${getRatingBg(score, colorThresholds)} flex items-center justify-center px-[15px] py-[10px] rounded-[6px] shrink-0`}>
            <span className="text-[#111928] text-sm font-normal leading-[18px] whitespace-nowrap">
                {RATING_LABEL} {Math.round(score * 10) / 10}%
            </span>
        </div>
    );
};

export default RatingBadge;
